import { render, staticRenderFns } from "./DataModel.vue?vue&type=template&id=283d213e&scoped=true"
import script from "./DataModel.vue?vue&type=script&lang=js"
export * from "./DataModel.vue?vue&type=script&lang=js"
import style0 from "./DataModel.vue?vue&type=style&index=0&id=283d213e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d213e",
  null
  
)

export default component.exports